import type { ThemeOptions } from '@mui/material/styles';

const shapes: NonNullable<ThemeOptions['shape']> = {
  borderRadius: 4,
};

export default shapes;
